import { DocumentType } from '@documents/models/document-type';
export function findDocumentType(
  typeName: string,
  documentTypes: DocumentType[],
) {
  return documentTypes.find((type) => type.name === typeName);
}
